<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>
          <page-title :title="pageTitle" />
          <hr />

          <div v-if="status == 'Invalid'">
            The link you followed is invalid.
          </div>

          <div v-if="status == 'Logout'">
            Log out and try again
          </div>

          <div v-if="status == 'Register'">
            <content-block slug="client-landing-first-time" :tokens="landingData" />
            
            <b-form @submit.prevent="onCreatePassword">
              <text-control form-name="createPassword" label="Password" v-model="signUpPassword" type="password" placeholder="Password" required min-length="8" />
              <text-control form-name="createPassword" label="Confirm Password" v-model="signUpConfirm" type="password" placeholder="Confirm Password" required min-length="8" :custom-validation="onValidateConfirmPassword" />

              <b-button type="submit" variant="primary">Create Password</b-button>
            </b-form>

          </div>

          <div v-if="status == 'Login'">
            <content-block slug="client-landing-returning" :tokens="landingData" />

            <b-alert v-if="logInError" show variant="danger">
              {{ logInError }}
            </b-alert>

            <b-form @submit.prevent="onLoginPassword">
              <text-control form-name="loginPassword" label="Password" v-model="loginPassword" type="password" placeholder="Password" required min-length="8" />

              <b-button type="submit" variant="primary">Continue</b-button>
              <hr />
              <p>
                <b-link @click="showPasswordReset=!showPasswordReset">Help! I forgot my password.</b-link>
              </p>
              <content-block v-if="showPasswordReset" slug="client-landing-password-reset" :tokens="landingData" />
              <b-button v-if="showPasswordReset" variant="primary" @click="requestPasswordReset">Reset Password</b-button>
            </b-form>
          </div>

          <div v-if="status == 'Continue'">
            <content-block slug="client-landing-continue" :tokens="landingData" />

            <b-button type="button" variant="primary" :to="activePageUrl">Continue</b-button>
          </div>
          
          <div v-if="status == 'Proctor'">
            <p>It's time for your client to tell their story.</p>

            <p>This survey is intended to be proctored to {{ landingData.clientFirstName }} {{ landingData.clientLastName }}.</p>

            <b-alert show v-if="landingData.isOffline" class="mb-3" variant="info">
              This questionnaire is being proctored offline. After it's been completed, you will need to synchronize this client's data before generating a mitigation report.
            </b-alert>

            <ul>
              <li>The survey automatically saves so you can come back to it as many times as you want</li>
              <li>Expect to spend up to 2 hours on this survey</li>
            </ul>

            <b-button type="button" variant="primary" :to="activePageUrl">Continue</b-button>
          </div>
          
          <div v-if="status == 'Completed'">
            <content-block slug="client-landing-completed" :tokens="landingData" />

            <b-button type="button" variant="primary" :to="activePageUrl">Continue</b-button>
          </div>
          
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import AuthMixin from '../Mixins/AuthMixin.vue';
import FormMixin from '../Mixins/FormMixin.vue';
import axios from "axios";

export default {
  name: "ClientLanding",
  mixins: [
    AuthMixin,
    FormMixin
  ],
  props: [
    'shortCode'
  ],
  data() {
    return {
      landingData: null,
      signUpPassword: '',
      signUpConfirm: '',
      loginPassword: '',
      showPasswordReset: false
    }
  },
  computed: {
    status: function () {
      if (!this.landingData)
        return 'Loading';
      else if (!this.landingData.isValidShortCode)
        return 'Invalid';
      else if (this.landingData.isProctorUser)
        return 'Proctor';
      else if (this.landingData.isOtherUser)
        return 'Logout';
      else if (this.landingData.isAuthenticated && this.landingData.activeFormId)
        return 'Continue';
      else if (this.landingData.isAuthenticated)
        return 'Completed';
      else if (!this.landingData.isAccountActivated)
        return 'Register';
      else
        return 'Login';
    },
    pageTitle: function () {
      if (this.status == 'Login' || this.status == 'Continue')
        return 'Welcome back, ' + this.landingData.clientFirstName + '.';
      else if (this.status == 'Register')
        return 'Welcome, ' + this.landingData.clientFirstName + '.';
      else
        return 'Welcome';
    },
    activePageUrl: function () {
      if (!this.landingData.activeFormId || !this.landingData.activePageId)
        return null;

      return '/client/form/' + this.landingData.activeFormId + '/page/' + this.landingData.activePageId;
    }
  },
  methods: {
    requestPasswordReset: function () {
      axios
        .post('/api/account/requestClientPasswordReset', {
          applicationUserId: this.landingData.clientApplicationUserId
        })
        .then(response => {

          this.$parent.showToast('A password reset message was sent to ' + this.landingData.clientEmailOrPhone + '.', {
            title: 'Password Reset Message Sent',
            variant: 'success',
            autoHideDelay: 5000
          });

        })
        .catch(error => {
          console.log(error);
        });    

    },
    load: function () {
      axios
        .get('/api/client/landingData?shortCode=' + this.shortCode)
        .then(response => {
          this.landingData = response.data;

          if (this.landingData.isOtherUser) {
            this.logOut();
            this.load();
          }
        })
        .catch(error => {
          console.log(error);
        });    
    },
    onLoginPassword: function () {
      axios.post('/api/account/login',
      {
        "email": this.landingData.clientEmail,
        "password": this.loginPassword
      })
      .then(response => {
        this.processAuthResponse(response);
        this.load();
      })
      .catch(error => {
        this.logInError = this.createErrorMessage(error);
      });
    },
    onCreatePassword: function () {
      if (!this.isFormValid('createPassword'))
        return;

      axios.post('/api/client/acceptInvite',
      {
        "shortCode": this.shortCode,
        "password": this.signUpPassword
      })
      .then(response => {
        this.processAuthResponse(response);
        this.load();
      })
      .catch(error => {
        console.log(error);
      });
    },
    onValidateConfirmPassword: function (newValue, oldValue) {
      if (newValue == this.signUpPassword)
        return true;
      
      return 'Your passwords must match.'
    }
  },
  watch: {
  },
  created() {
  },
  async mounted () {
    this.load();
  }
};
</script>